<template>
    <v-card :class="{'px-3 py-4': $vuetify.breakpoint.smAndDown, 'px-5 py-5': $vuetify.breakpoint.mdAndUp}" :style="$vuetify.breakpoint.lgAndUp ? 'width:1134px' : ''">
        <v-form @submit.prevent>
            <v-icon class="modal-close" @click.native="close_wrapper('user_info')" aria-hidden="true" translate="no">close</v-icon>
            <v-card-title :class="{'mb-3 headline': $vuetify.breakpoint.smAndDown, 'mb-5 display-1': $vuetify.breakpoint.mdAndUp}">{{$t("Редактировать информацию о себе")}} </v-card-title>
            <v-layout column>
                <v-layout row wrap>
                    <v-flex md4 sm6 xs12
                            :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Фамилия")}}</div>
                        <inputBase v-model="family" :placeholder="$t('Введите фамилию')" name="surname"
                                   :value="user_family || ''" :class="{ 'form-group--error': !$v.surname.alpha && $v.surname.$dirty }"
                        />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            :class="{'mt-4': $vuetify.breakpoint.xs, 'pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Имя")}}</div>
                        <inputBase v-model="first_name" :placeholder="$t('Введите имя')" name="name"
                                   :value="user_name || ''" :v="$v.name" :class="{ 'form-group--error': !$v.name.alpha && $v.name.$dirty }"
                        />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            :class="{'pr-4': $vuetify.breakpoint.sm, 'mt-4': $vuetify.breakpoint.smAndDown}"
                    >
                        <div class="grey-text mb-2">{{$t("Отчество")}}</div>
                        <inputBase v-model="patronymic" :placeholder="$t('Введите отчество')" name="patronymic"
                                   :value="user_patronymic || ''" :class="{ 'form-group--error': !$v.patr.alpha && $v.patr.$dirty }"
                        />
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-4">
                    <v-flex md4 sm6 xs12
                            :class="{'pr-0': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Дата рождения")}}</div>
                        <datepicker :value="default_values.birthday" :placeholder="user_birthday" :offset="false"
                                    @change="get_birth_date($event)"
                        />
                    </v-flex>
                    <v-flex md4 sm6 xs12
                            :class="{'mt-4': $vuetify.breakpoint.xs, 'pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}"
                    >
                        <div class="grey-text mb-2">{{$t("Номер телефона")}}</div>
                        <inputBase v-mask="phoneMask" v-model="model_phone" :value="user_phone" />
                    </v-flex>
                </v-layout>
                <v-layout row mt-4>
                    <v-flex>
                        <div class="grey-text mb-2">{{$t("Дополнительная информация")}}</div>
                        <textareaBase v-model="model_additional" :placeholder="$t('Введите текст')" rows="4"
                                      :value="additional"
                        />
                    </v-flex>
                </v-layout>
            </v-layout>
            <v-card-actions class="mt-4">
                <buttonRed @click.native="submit(user_id, user)">{{$t("Применить")}}</buttonRed>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import {required, helpers} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import buttonRed from '@/components/ui/buttons/button_red';
import inputBase from '@/components/ui/inputs/base/input';
import textareaBase from '@/components/ui/inputs/base/textarea';
import datepicker from '@/components/ui/inputs/base/datepicker.vue';
import {mask} from 'vue-the-mask';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import {get, post} from '@/lib/axios';
import api from '../../../../api/index.js';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
const alpha = helpers.regex('alpha', /^[ЁёА-яa-zA-Z\-\s]*$/);
import { VueMaskDirective } from 'v-mask'


export default {
  directives:
        {
          mask: VueMaskDirective
        },
  components: {
    buttonRed,
    inputBase,
    textareaBase,
    datepicker,
  },
  mixins: [validationMixin],
  props : {
    value: {
      type: String,
    },
  },
  validations: {
    name: {
      alpha,
    },
    surname: {
      alpha,
    },
    patr: {
      alpha,
    },
  },
  data() {
    return {
      name          : ' ',
      surname       : ' ',
      patr          : '',
      errors        : false,
      default_values: {
        name      : '',
        family    : '',
        patronymic: '',
        birthday  : '',
        phone     : '',
        additional: '',
      },
      date: '',
    };
  },
  computed: {
    ...mapGetters('profile/modals', [
      'user_info',
    ]),
    ...mapGetters('profile/user', [
      'user',
      'user_name',
      'user_family',
      'user_patronymic',
      'additional',
      'user_birthday',
      'user_phone',
      'user_id']),

    first_name: {
      get() {
        return this.user_name;
      },
      set($event) {
        this.name = $event.target.value;
        this.$v.name.$touch();
        return this.SET_USER_NAME($event.target.value);
      },
    },
    family: {
      get() {
        return this.user_family;
      },
      set($event) {
        this.surname = $event.target.value;
        this.$v.surname.$touch();
        return this.SET_USER_FAMILY($event.target.value);
      },
    },
    patronymic: {
      get() {
        return this.user_patronymic;
      },
      set($event) {
        this.patr = $event.target.value;
        this.$v.patr.$touch();
        return this.SET_USER_PATRONIMY($event.target.value);
      },
    },
    model_additional: {
      get() {
        return this.additional;
      },
      set($event) {
        return this.SET_USER_ADDITIONAL($event.target.value);
      },
    },
    model_phone: {
      get() {
        return this.user_phone;
      },
      set($event) {
        return this.SET_USER_PHONE($event.target.value);
      },
    },
    ...mapGetters('company_profile/info', ['selected_country']),
    phoneMask() {
      let country = this.selected_country;
      let iso = '';

      if (country) {
        iso = country.iso;
      }

      return !iso || iso === 'RU' ? '+7(###)-###-##-##' : '';
    }
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  mounted() {
    this.default_values.name = this.user_name;
    this.default_values.family = this.user_family;
    this.default_values.patronymic = this.user_patronymic;
    this.default_values.birthday = this.user_birthday || '';
    this.default_values.phone = this.user_phone;
    this.default_values.additional = this.additional;
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapActions('profile/user', ['save_user_info']),
    get_birth_date(value) {
      this.date = new dayjs(value.target._flatpickr.selectedDates[0]).format('DD.MM.YYYY');
      this.SET_BIRTHDAY(this.date);
    },
    async submit(user_id, user) {
      if (!this.date && !this.default_values.birthday) {
        this.SET_BIRTHDAY('');
      }

      if (document.querySelector('.form-group--error')) {
        this.errors = true;
      } else {
        this.errors = false;
        this.CLOSE_MODAL('user_info');
        let id = user_id;
        let st = user;
        await this.save_user_info({id, st});
      }
    },
    ...mapMutations('profile/modals', [
      'CLOSE_MODAL',
    ]),
    ...mapMutations('profile/user', [
      'SET_USER_NAME',
      'SET_USER_FAMILY',
      'SET_USER_PATRONIMY',
      'SET_USER_ADDITIONAL',
      'SET_BIRTHDAY',
      'SET_USER_PHONE',
      'UPDATE_USER',
    ]),
    close_wrapper() {
      this.SET_USER_NAME(this.default_values.name);
      this.SET_USER_FAMILY(this.default_values.family);
      this.SET_USER_PATRONIMY(this.default_values.patronymic);
      this.SET_BIRTHDAY(this.default_values.birthday);
      this.SET_USER_PHONE(this.default_values.phone);
      this.SET_USER_ADDITIONAL(this.default_values.additional);
      this.CLOSE_MODAL('user_info');
    },
  },

};
</script>

